import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  photo: string;
}
const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  photo
}: TestimonialProps) => <div className="bg-brand-card p-3 rounded-xl border border-white/10 flex flex-col h-full hover:border-white/20 transition-colors" data-id="element-214">
    <div className="flex items-center mb-2" data-id="element-215">
      <img src={photo} alt={name} className="w-9 h-9 rounded-full object-cover mr-2 shrink-0 border border-white/10" data-id="element-216" />
      <div data-id="element-217">
        <div className="flex text-brand-gold mb-0.5" data-id="element-218">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-2.5 h-2.5 fill-current" data-id="element-219" />)}
        </div>
        <p className="font-semibold text-white text-[10px] md:text-xs leading-none" data-id="element-220">
          {name}
        </p>
        <p className="text-[9px] text-white/60 font-medium leading-tight" data-id="element-221">
          {location}
        </p>
      </div>
    </div>
    <p className="text-gray-300 text-[11px] md:text-xs italic flex-grow leading-relaxed font-normal" data-id="element-222">
      "{text}"
    </p>
  </div>;
export function TestimonialsSection1() {
  const testimonials = [{
    initials: 'VM',
    name: 'Valeria M.',
    location: 'Profesora de Secundaria Técnica — Buenos Aires, Argentina',
    text: 'Organicé los tres trimestres de Informática y Programación en una sola tarde.',
    photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face'
  }, {
    initials: 'RC',
    name: 'Roberto C.',
    location: 'Docente de Tecnología — Ciudad de México, México',
    text: 'Mis alumnos por fin dejan el celular y programan con ganas.',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face'
  }, {
    initials: 'SP',
    name: 'Sandra P.',
    location: 'Profesora de Programación — Bogotá, Colombia',
    text: 'Nunca más llegué a una clase sin saber cómo explicar un concepto complejo.',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face'
  }];
  return <section className="py-2 md:py-3 px-3 bg-brand-cardAlt border-b border-white/5" data-id="element-223">
      <div className="max-w-5xl mx-auto" data-id="element-224">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2" data-id="element-225">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-226" />)}
        </div>
      </div>
    </section>;
}
export function TestimonialsSection2() {
  const testimonials = [{
    initials: 'VM',
    name: 'Valeria M.',
    location: 'Profesora de Informática | Buenos Aires, Argentina',
    text: 'Compré el Kit un domingo a la noche y el lunes ya tenía la unidad de Funciones lista con ejercicios, evaluación y todo. El nivel de los materiales es excelente: logran bajar conceptos de programación orientada a objetos a un lenguaje que mis alumnos de 15 años entienden y practican. Me devolvió mis fines de semana y la pasión por entrar al aula.',
    photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face'
  }, {
    initials: 'RC',
    name: 'Roberto C.',
    location: 'Docente de Tecnología | Ciudad de México, México',
    text: 'Lo que más valoro es el Bono de Ejercicios Anti-IA. Estaba cansado de que todos mis alumnos entregaran código generado por ChatGPT. Con estas actividades de contexto personal y resolución real, por fin puedo evaluar quién piensa de verdad y quién no. Es la mejor inversión que hice este año para mi carrera.',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face'
  }, {
    initials: 'SP',
    name: 'Sandra P.',
    location: 'Profesora de Programación | Bogotá, Colombia',
    text: 'Enseñar bucles siempre fue un reto por la falta de materiales que conecten con la realidad de mis alumnos. El Tomo 3 sobre estructuras repetitivas tiene ejemplos con simuladores de juegos y sistemas de ventas que engancharon a mis chicos de inmediato. Mis colegas me preguntan qué curso hice para renovar tanto mis clases.',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face'
  }, {
    initials: 'FL',
    name: 'Felipe L.',
    location: 'Docente de Computación | Santiago, Chile',
    text: 'El sistema de progresión es perfecto. En Chile el currículum varía entre establecimientos pero el Kit se adapta sin problemas porque la lógica de programación es universal. Las planificaciones me ahorran horas de preparación. No improviso nunca más.',
    photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face'
  }, {
    initials: 'AM',
    name: 'Ana M.',
    location: 'Docente de Informática | Lima, Perú',
    text: 'Lo que me sorprendió fue el Bono de Errores Comunes. Antes cuando un alumno tenía un error de lógica yo sabía qué estaba mal pero no sabía cómo explicarlo. Ahora tengo la analogía perfecta para cada situación. Mis alumnos entienden los errores al primer intento y eso cambió completamente el clima de la clase.',
    photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=face'
  }];
  return <section className="py-3 md:py-4 px-3 bg-brand-cardAlt border-y border-white/5" data-id="element-227">
      <div className="max-w-6xl mx-auto" data-id="element-228">
        <h2 className="text-lg md:text-2xl font-bold text-center mb-3 text-white uppercase tracking-tight" data-id="element-229">
          🗨️ Lo que dicen los docentes que ya tienen su Kit:
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2" data-id="element-230">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-231" />)}
        </div>
      </div>
    </section>;
}